import {
  createFrontendPlugin,
  PageBlueprint,
} from '@backstage/frontend-plugin-api';
import { RiGithubLine, RiLineChartLine, RiStackLine } from '@remixicon/react';
import { githubRouteRef, rootRouteRef, spaceliftRouteRef } from './routes';

const doraMetricsPage = PageBlueprint.make({
  name: 'dora-metrics',
  params: {
    path: '/dora-metrics',
    title: 'DORA Metrics',
    icon: <RiLineChartLine />,
    routeRef: rootRouteRef,
    noHeader: true,
    loader: async () =>
      import('./components/DoraMetricsPage').then(m => <m.DoraMetricsPage />),
  },
});

const githubDoraPage = PageBlueprint.make({
  name: 'dora-github',
  params: {
    path: '/dora-metrics/github',
    title: 'GitHub DORA',
    icon: <RiGithubLine />,
    routeRef: githubRouteRef,
    noHeader: true,
    loader: async () =>
      import('./components/DoraGithubPage').then(m => <m.DoraGithubPage />),
  },
});

const spaceliftDoraPage = PageBlueprint.make({
  name: 'dora-spacelift',
  params: {
    path: '/dora-metrics/spacelift',
    title: 'Spacelift DORA',
    icon: <RiStackLine />,
    routeRef: spaceliftRouteRef,
    noHeader: true,
    loader: async () =>
      import('./components/DoraSpaceliftPage').then(m => (
        <m.DoraSpaceliftPage />
      )),
  },
});

export const doraMetricsPlugin = createFrontendPlugin({
  pluginId: 'dora-metrics',
  extensions: [doraMetricsPage, githubDoraPage, spaceliftDoraPage],
  routes: {
    root: rootRouteRef,
    github: githubRouteRef,
    spacelift: spaceliftRouteRef,
  },
});
